var escape = require("../../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".part-header-deferred[data-v-65b6a0ee]{display:inline-block;background-size:contain;width:19px;height:19px;text-align:center;line-height:20px;color:#fff;font-weight:400;font-size:10px;text-decoration:none}.part-header-deferred_heart[data-v-65b6a0ee]{background:url(" + escape(require("./heart.svg")) + ") center 2px no-repeat}.part-header-deferred_basket[data-v-65b6a0ee]{background:url(" + escape(require("./basket.svg")) + ") center -1px no-repeat}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-65b6a0ee","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/parts/header/deferred/component.vue
// module id = 35bd90399e7e14a6e312
// module chunks = 7